import React from "react";
import { Link } from "gatsby";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

function Explorecaseslider() {
  return (
    <section className="explorecase_slider p-100" id="case_btn">
      <Container>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="my-auto">
            <Swiper
              loop={true}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }}
              spaceBetween={0}
              modules={[Autoplay, Pagination]}
              pagination={{ clickable: true }}
              breakpoints={{
                320: {
                  slidesPerView: 1,
                },
                768: {
                  slidesPerView: 1,
                },
                1024: {
                  slidesPerView: 1,
                },
                1366: {
                  slidesPerView: 1,
                },
                1600: {
                  slidesPerView: 1,
                },
              }}
              className=""
            >
              <SwiperSlide>
                <Row>
                  <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                    <h2>Your Nurse: Telehealth Platform</h2>
                    <p>
                      Offers online consultations, virtual check-ups, and
                      appointment scheduling to ensure near-zero downtime in
                      telehealth services for patients and practitioners.
                    </p>
                    <Link
                      to="/case-studies/nurse-practitioners"
                      className="border_btn"
                      aria-label="TekRevol Contact"
                    >
                      View Case Study!
                    </Link>
                  </Col>
                  <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                    <div className="explore_slider_img">
                      <StaticImage
                        src="../../images/services-usa/healthcare-new/explore_case/nurse_case_2.webp"
                        alt="nurse-casestudy"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["webp"]}
                        width={1032}
                        height={774}
                      />
                    </div>
                  </Col>
                </Row>
              </SwiperSlide>
              <SwiperSlide>
                <Row>
                  <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                    <h2>Kinect: AI-Powered Patient Care</h2>
                    <p>
                      Integrates GPT-4 AI for real-time message aggregation,
                      social content monitoring, and automated response
                      generation, enhancing patient care and engagement.
                    </p>
                    <Link
                      to="/case-studies/kinekt"
                      className="border_btn"
                      aria-label="TekRevol Contact"
                    >
                      View Case Study!
                    </Link>
                  </Col>
                  <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                    <div className="explore_slider_img">
                      <StaticImage
                        src="../../images/services-usa/healthcare-new/explore_case/kineckt_case_3.webp"
                        alt="kineckt-casestudy"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["webp"]}
                        width={1032}
                        height={774}
                      />
                    </div>
                  </Col>
                </Row>
              </SwiperSlide>
              <SwiperSlide>
                <Row>
                  <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                    <h2>MiloCare+: Cross-Platform EMR Solution</h2>
                    <p>
                      Secure and efficient EMR management, featuring real-time
                      data synchronization and seamless cross-platform
                      performance.
                    </p>
                    <Link
                      to="/case-studies/milocare"
                      className="border_btn"
                      aria-label="TekRevol Contact"
                    >
                      View Case Study!
                    </Link>
                  </Col>
                  <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                    <div className="explore_slider_img">
                      <StaticImage
                        src="../../images/services-usa/healthcare-new/explore_case/milo_case_1.webp"
                        alt="milo-casestudy"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["webp"]}
                        width={1032}
                        height={774}
                      />
                    </div>
                  </Col>
                </Row>
              </SwiperSlide>
            </Swiper>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Explorecaseslider;
